import { render } from "./SortingButton.vue?vue&type=template&id=785d0b9a"
import script from "./SortingButton.vue?vue&type=script&lang=js"
export * from "./SortingButton.vue?vue&type=script&lang=js"

import "./SortingButton.vue?vue&type=style&index=0&id=785d0b9a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__